// extracted by mini-css-extract-plugin
export default {"overlay_img":"Overlay_overlay_img__ZsLC4","done":"Overlay_done__CdAJJ","overlay_container":"Overlay_overlay_container__Y9oyI"};